import './App.css';
import Board from './components/Board';
import Keyboard from './components/Keyboard'
import GameOver from './components/GameOver'
import Header from './components/Header'
import { createContext, useState, useEffect } from 'react'
import { boardDefault, generateWordSet, randWord } from './Words'

export const AppContext = createContext();

function App() {
  const [board, setBoard] = useState(boardDefault);
  const [currAttempt, setCurrAttempt] = useState({attempt: 0, letterPos: 0})
  const [wordSet, setWordSet] = useState(new Set())
  const [correctLetters, setCorrectLetters] = useState([])
  const [almostLetters, setAlmostLetters] = useState([])
  const [disabledLetters, setDisabledLetters] = useState([])
  const [gameOver, setGameOver] = useState({
                                    gameOver: false,
                                    guessedWord: false,
                                  })

  const [correctWord, setCorrectWord] = useState("")

  useEffect(() => {
    setWordSet(generateWordSet())
    setCorrectWord(randWord())
  }, [])

  const onSelectLetter = (keyVal) => {
    if (currAttempt.letterPos > 4) return;
        const newBoard = [...board]
        newBoard[currAttempt.attempt][4 - currAttempt.letterPos] = keyVal
        setBoard(newBoard)
        setCurrAttempt({...currAttempt, letterPos: currAttempt.letterPos + 1})}


  const onDelete = () => {
    if (currAttempt.letterPos === 0) return;
          const newBoard = [...board];
          newBoard[currAttempt.attempt][4 - currAttempt.letterPos + 1] = "";
          setBoard(newBoard)
          setCurrAttempt({...currAttempt, letterPos: currAttempt.letterPos - 1})
}
  const onEnter = () => {
    if (currAttempt.letterPos !== 5) return
    
    let currWord = "";
    for (let i = 0; i < 5; i++) {
      currWord += board[currAttempt.attempt][4-i];
    }

    if (wordSet.has(currWord) || !wordSet.has(currWord)) {
      setCurrAttempt({attempt: currAttempt.attempt + 1, letterPos: 0})  
    } else {
      alert("Word not found")
    }

    if(currWord === correctWord) {
      setGameOver({gameOver: true, guessedWord: true})
      return;
    }
    
    if (currAttempt.attempt === 5) {
      setGameOver({gameOver: true, guessedWord: false})
    }

}
  return (
    <div className="App">
      <Header />
      <AppContext.Provider value={{ 
        board,
        setBoard,
        currAttempt,
        setCurrAttempt,
        onSelectLetter,
        onDelete,
        onEnter,
        correctWord,
        correctLetters,
        setCorrectLetters,
        almostLetters,
        setAlmostLetters,
        disabledLetters,
        setDisabledLetters,
        gameOver,
        setGameOver
      }}>
        <div className="game">
          <Board />
          {gameOver.gameOver ? <GameOver /> : <Keyboard />}
        </div>
      </AppContext.Provider>
    </div>
  );
}

export default App;
